import React from "react";
import { ButtonDefault } from "./style.js";
import { Text, Icon, LoadingSpin } from "../../../components";

export default function Button({
  title = "",
  onClick,
  form,
  hasIcon = false,
  iconConfig,
  textConfig,
  loading = false,
  disabled = false,
  hasLoad,
  ...options
}) {
  return (
    <ButtonDefault
      onClick={onClick}
      form={form}
      disabled={loading || disabled}
      {...options}
    >
      {hasIcon && <Icon {...iconConfig} />}
      {hasLoad && <LoadingSpin
        show={loading}
        weight={"5px"}
        size={"20px"}
        position="absolute"
        left="10px"
        backColor="#1a2454"
        frontColor="transparent"
      />}
      <Text color="#fff" cursor={"pointer"} {...textConfig}>
        {loading ? "Carregando..." : title}
      </Text>
    </ButtonDefault>
  );
}
